module.exports = __webpack_public_path__ + "static/media/Eagle.007bcecc.png";